// Which site this build produces. Set at build time via VITE_SITE.
export const SITE_KEYS = ["india", "navimumbai", "pune", "bangalore", "shirdi"];

const requested = import.meta.env.VITE_SITE || "navimumbai";

if (!SITE_KEYS.includes(requested)) {
  throw new Error(
    `Invalid VITE_SITE "${requested}". Use one of: ${SITE_KEYS.join(", ")}`
  );
}

export const SITE_KEY = requested;

export const SITE_ORIGINS = {
  india: "https://hairclinique.in",
  navimumbai: "https://navimumbai.hairclinique.in",
  pune: "https://pune.hairclinique.in",
  bangalore: "https://bangalore.hairclinique.in",
  shirdi: "https://shirdi.hairclinique.in",
};

export const SITE_ORIGIN = SITE_ORIGINS[SITE_KEY];
// Menu titles and addresses of the three "HT <place>" pages.
// hairclinique.in says India, navimumbai.hairclinique.in says Navi Mumbai.
const place = SITE_KEY === "navimumbai"
  ? { name: "Navi Mumbai", slug: "navi-mumbai" }
  : { name: "India", slug: "india" };

export const HT = {
  menu: `HT ${place.name}`,
  inLabel: `Hair Transplant in ${place.name}`,
  costLabel: `Hair Transplant Cost in ${place.name}`,
  surgeryLabel: `Hair Transplant Surgery in ${place.name}`,
  inPath: `/hair-transplant-in-${place.slug}.php`,
  costPath: `/hair-transplant-cost-in-${place.slug}.php`,
  surgeryPath: `/hair-transplant-surgery-in-${place.slug}.php`,
};